import { render, staticRenderFns } from "./ListDocumentContact.vue?vue&type=template&id=6edd032f"
import script from "./ListDocumentContact.vue?vue&type=script&lang=js"
export * from "./ListDocumentContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports